import { render, staticRenderFns } from "./Detail-Bug-Report.vue?vue&type=template&id=ea64006e&"
import script from "./Detail-Bug-Report.vue?vue&type=script&lang=js&"
export * from "./Detail-Bug-Report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports